import Api from './axiosInstance'
import { API_PRICING, API_INVENTORY, FUNCTION_JOBS } from 'utils/constants'

type CallByInventoryJobParams = {
  storeIds: any[]
}

type CallByPriceJobParams = {
  storeIds: any[]
  aggregatorIds: any[]
}

// Triggers the job to create CSV Files for each aggregators
const createFtpJob = () => {
  return Api.post({ url: FUNCTION_JOBS.GENERATE_FTP_FILE })
}

// call the inventory and toggle the isOnStock to true for selected stores
const callByInventoryJob = (data: CallByInventoryJobParams) => {
  return Api.patch({ url: API_INVENTORY.CALL_BY_INVENTORY, data })
}

// flush the pricing data for selected stores and aggregators
const callByPriceJob = (data: CallByPriceJobParams) => {
  return Api.patch({ url: API_PRICING.CALL_BY_PRICE, data })
}

export { callByInventoryJob, callByPriceJob, createFtpJob }
